import { makeAutoObservable } from 'mobx';

import {
  SOLUTION_TYPE,
  SOLUTION_TYPE_FILTER,
  SolutionType,
  SolutionTypeFilter,
} from '../constants/user-info/solutionType';
import { unreadScansService } from '../services/unreadScansService';
import { resetAllStore } from './resetAllStore';

class UnreadScansCountStore {
  scanIqUnreadCount: number = 0;
  nutritionUnreadCount: number = 0;

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });
  }

  setDefaultValues() {
    this.scanIqUnreadCount = 0;
    this.nutritionUnreadCount = 0;
  }

  private setCountForSolution(solutionType: SolutionType, count: number) {
    if (solutionType === SOLUTION_TYPE.SCAN_IQ) {
      this.scanIqUnreadCount = count;
    }
    if (solutionType === SOLUTION_TYPE.NUTRITION) {
      this.nutritionUnreadCount = count;
    }
  }

  async getUnreadScansCount(solutionType: SolutionType | null) {
    // We don't need to show unread scans count for challenge solution
    if (!solutionType || solutionType === SOLUTION_TYPE.CHALLENGE) {
      return;
    }

    const count = await unreadScansService.getUnreadScansCount(solutionType);
    this.setCountForSolution(solutionType, count);
  }

  async markScanIqCustomerScanSeen(customerId: number) {
    await unreadScansService.markScanIqCustomerScanSeen(customerId);
    await this.getUnreadScansCount(SOLUTION_TYPE.SCAN_IQ);
  }

  async markNutritionCustomerScanSeen(customerId: number) {
    await unreadScansService.markNutritionCustomerScanSeen(customerId);
    await this.getUnreadScansCount(SOLUTION_TYPE.NUTRITION);
  }

  async markAllScansRead(solutionType: SolutionTypeFilter) {
    await unreadScansService.markAllScansRead(solutionType);
    if (solutionType === SOLUTION_TYPE_FILTER.ALL) {
      await Promise.all([
        this.getUnreadScansCount(SOLUTION_TYPE.SCAN_IQ),
        this.getUnreadScansCount(SOLUTION_TYPE.NUTRITION),
      ]);
    } else {
      await this.getUnreadScansCount(solutionType);
    }
  }
}

const unreadScansCountStore = new UnreadScansCountStore();
resetAllStore.addResetMethod(unreadScansCountStore.setDefaultValues);

export { unreadScansCountStore, UnreadScansCountStore };
